import SEOPageTemplate from '../components/SEOPageTemplate';

const ChauffeurPittsburgh = () => (
  <SEOPageTemplate
    city="Pittsburgh"
    state="PA"
    route="/chauffeur-pittsburgh-pa"
    imageSrc="/pittsburgh-pa-limo.jpg"
    introduction="In Pittsburgh, Pennsylvania's dynamic city of innovation, TiLimousine provides a transportation service that understands the unique character of this revitalized metropolis. Our chauffeurs are intimately familiar with Pittsburgh's distinctive landscape, from the bustling Strip District to the innovative tech hubs. Whether you're visiting Carnegie Mellon University, attending a conference at the Convention Center, or exploring the city's growing healthcare and robotics sectors, our service ensures your journey through Pittsburgh is as forward-thinking as the city itself."
    testimonial={{
      quote: "As a robotics industry executive, I frequently host international partners visiting our Pittsburgh headquarters. TiLimousine's chauffeurs understand the importance of showcasing our city's transformation. Their knowledge of Pittsburgh's tech ecosystem and cultural landmarks has been invaluable for our business.",
      author: "David R.",
      role: "CTO, Pittsburgh Robotics Institute"
    }}
    services={[
      'Luxury chauffeur service for airport transfers and FBO pickup',
      'Executive car service and black car service for business travel',
      'Hourly chauffeur hire and as-directed black car service',
      'Private driver service for events, weddings, and VIPs',
      'Long-distance city-to-city rides: Pittsburgh ⇄ NYC, Pittsburgh ⇄ Philadelphia',
      'Professional chauffeur company for meetings and corporate events',
      'Livery service and luxury livery transportation',
      'Town car service and car and driver rental',
      'Book a chauffeur in Pittsburgh',
      'Best chauffeur in Pennsylvania',
      'Chauffeured transportation for VIPs',
      'Luxury car with driver',
      'Business travel car service',
      'Limo vs black car service Pittsburgh',
      'Best executive car service in Pittsburgh',
      'FBO pickup with luxury car',
      'Chauffeur for meetings and corporate events'
    ]}
    airports={[
      'Pittsburgh International Airport (PIT)',
      'Allegheny County Airport (AGC)',
      'Signature Flight Support',
      'Atlantic Aviation',
      'Teterboro Airport (TEB)',
      'JFK',
      'LGA',
      'Philadelphia International Airport (PHL)'
    ]}
    neighborhoods={[
      'Downtown Pittsburgh',
      'Strip District',
      'Oakland',
      'Shadyside',
      'Squirrel Hill',
      'Lawrenceville',
      'South Side',
      'North Shore',
      'East Liberty',
      'Bakery Square',
      'Robotics Row',
      'Greater Pittsburgh Area'
    ]}
  />
);

export default ChauffeurPittsburgh; 